import React, { useContext, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// Componentes
import VistaVinculacion from "../vistas/VistaVinculacion";
import FormVinculacion from "../formularios/FormVinculacion";
// Contexto
import { ModalContext } from "../../../context/modalContext";
import { AlertBoxContext } from "../../../context/alertBoxContext";
import { ConfirmModalContext } from "../../../context/confirmModalContext";
// jquery
import $ from "jquery";
// Custom spinner
import CustomSpinner from "../../generic/CustomSpinner";

const Vinculacion = ({ idProvincia, idComunidad, vinculacion, deleteVinculacionState, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);
  // Ventana de confirmación
  const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);
  // UEF para guardar los datos de la vinculación
  const [datosVinculacion, setDatosVinculacion] = useState(vinculacion);

  // Edita una vinculacion de una comunidad
  const putDatosVinculacion = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/comunidades/${idComunidad}/eclesiasticos/${datosVinculacion.id}`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Elimina una vinculación de una comunidad
  const deleteDatosVinculacion = () => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/comunidades/${idComunidad}/eclesiasticos/${datosVinculacion.id}`,
      method: "DELETE",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Manejador para el put de los datos de las vinculiaciones de la comunidad
  const handlePutDatosVinculacion = (data) => {
    setLoading(true);
    modalSetShow(false);
    // Hacemos el put para los datos de las vinculaciones
    putDatosVinculacion(data)
      .then((response) => {
        setDatosVinculacion(response);
        addAlert("Exito", "Se ha editado correctamente la vinculación eclesiástica", "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  // Manejador para el delete de los datos de las vinculaciones de la comunidad
  const handleDeleteDatosVinculacion = (data) => {
    setLoading(true);
    modalSetShow(false);
    // Hacemos el delete para los datos de la vinculacion
    deleteDatosVinculacion(data)
      .then(() => {
        deleteVinculacionState(data.id);
        addAlert("Exito", "Se ha eliminado correctamente la vinculación eclesiástica", "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  return (
    <div className="position-relative">
      <CustomSpinner animation={"border"} loading={loading} />
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              {datosVinculacion?.type}
            </Accordion.Toggle>
            <Button
              onClick={() => {
                confirmModalSetTitle(`Eliminar vinculación con ${vinculacion.type}`);
                confirmModalSetContent(<p> {"¿Está seguro de que quiere eliminarla?"} </p>);
                confirmModalSetFunction(() => {
                  handleDeleteDatosVinculacion(datosVinculacion);
                });
                confirmModalSetShow(true);
              }}
              variant="outline-danger"
              size="sm"
              className="float-right mr-4"
            >
              Eliminar
            </Button>
            <Button
              variant="outline-primary"
              size="sm"
              className="float-right mr-4"
              onClick={() => {
                modalSetShow(true, "80%");
                modalSetTitle("Editar vinculación eclesiástica");
                modalSetContent(<FormVinculacion defaultValues={datosVinculacion} submissionHandler={handlePutDatosVinculacion} />);
              }}
            >
              Editar
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className={"bg-light"}>
              <VistaVinculacion datosVinculacion={datosVinculacion} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Vinculacion;
